export default "__VITE_ASSET__DBWe42H9__"